import React,{useCallback,useEffect,useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faUsers, faClock, faPlay, faRobot, faBrain, faChartLine, faCode, faProjectDiagram, faCloud, faCheckCircle, faDatabase, faServer, faLaptopCode, faCertificate, faBriefcase } from '@fortawesome/free-solid-svg-icons';
import './HeroSection.css';
 
const CloudEngineering = () => {
    const [showModal, setShowModal] = useState(false);
      const [formCourseName, setFormCourseName] = useState('Cloud Engineering');
      const [formData, setFormData] = useState({
        fullName: '',
        mobileNumber: '',
        email: '',
      });
    
      const openModal = () => setShowModal(true);
      const closeModal = useCallback(() => {
        setShowModal(false);
        setFormData({ fullName: '', mobileNumber: '', email: '' });
      }, []);
    
      useEffect(() => {
        const handleEsc = (e) => {
          if (e.key === 'Escape') closeModal();
        };
        window.addEventListener('keydown', handleEsc);
        return () => window.removeEventListener('keydown', handleEsc);
      }, [closeModal]);
    
      const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'mobileNumber') {
          const digitsOnly = value.replace(/\D/g, '');
          if (digitsOnly.length <= 10) {
            setFormData(prev => ({ ...prev, [name]: digitsOnly }));
          }
        } else {
          setFormData(prev => ({ ...prev, [name]: value }));
        }
      };
    
      const handleSubmit = async (e) => {
        e.preventDefault();
        const { fullName, mobileNumber, email } = formData;
    
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
        if (!fullName || !emailRegex.test(email) || mobileNumber.length !== 10) {
          alert('Please fill in valid details.');
          return;
        }
    
        try {
          const response = await fetch('https://api.dikshasea.in/api/enrollments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ...formData, course: formCourseName }),
          });
    
          const result = await response.json();
          if (response.ok) {
            alert('Enrollment successful!');
            closeModal();
          } else {
            alert(result.message || 'Submission failed');
          }
        } catch (err) {
          console.error(err);
          alert('Error submitting form');
        }
      };
    
  return (
    <>
      <section className="hero-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h1 className="hero-title">
                Master <span className="hero-highlight">Cloud Engineering</span>
              </h1>
              <p className="hero-subtitle">
                Become an expert in cloud technologies with our comprehensive course designed for IT professionals.
                Learn to design, deploy, and manage scalable cloud solutions across major platforms.
              </p>
             
              <div className="course-meta">
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faStar} />
                  </div>
                  <div>
                    <div className="fw-bold">4.8/5.0</div>
                    <small className="text-muted">(1,890 reviews)</small>
                  </div>
                </div>
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faUsers} />
                  </div>
                  <div>
                    <div className="fw-bold">6,500+</div>
                    <small className="text-muted">Students</small>
                  </div>
                </div>
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faClock} />
                  </div>
                  <div>
                    <div className="fw-bold">60 hours</div>
                    <small className="text-muted">Content</small>
                  </div>
                </div>
              </div>
             
               <button className="btn btn-primary btn-lg px-4" onClick={openModal}>
                  Enroll Now
                </button>
            </div>
            <div className="col-lg-6 mt-5 mt-lg-0">
              <div className="ratio ratio-16x9">
                <img
                  src="subcourses-images/cloud-engi.jpg"
                  alt="Cloud Engineering Course"
                  className="img-fluid rounded-3 shadow"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
     <div className="container">
      <div className="course-details">
        <div className="course-content">
          {/* About Course */}
          <section className="about-course">
            <h2 className="section-title">About This Course</h2>
            <p>This comprehensive Cloud Engineering program will transform you into a cloud expert, capable of designing and implementing solutions across AWS, Azure, and Google Cloud platforms. You'll learn infrastructure as code, cloud security, and architecture best practices.</p>
            <p>Through hands-on labs and real-world scenarios, you'll gain the skills needed to deploy and manage enterprise-grade cloud environments.</p>
          </section>
         
          {/* Curriculum */}
          <section className="curriculum">
            <h2 className="section-title">Curriculum</h2>
           
            <div className="curriculum-item">
              <h3><FontAwesomeIcon icon={faCloud} className="me-2" /> Module 1: Cloud Fundamentals</h3>
              <p>Master the core concepts and services of major cloud platforms</p>
              <div className="topics">
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Cloud computing models (IaaS, PaaS, SaaS)</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Virtualization and containerization</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Cloud storage solutions</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Networking in the cloud</div>
              </div>
            </div>
           
            <div className="curriculum-item">
              <h3><FontAwesomeIcon icon={faServer} className="me-2" /> Module 2: AWS Cloud Services</h3>
              <p>Deep dive into Amazon Web Services infrastructure</p>
              <div className="topics">
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> EC2, S3, and VPC configuration</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> AWS Lambda and serverless architecture</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> RDS and DynamoDB databases</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> IAM and security best practices</div>
              </div>
            </div>
           
            <div className="curriculum-item">
              <h3><FontAwesomeIcon icon={faCloud} className="me-2" /> Module 3: Microsoft Azure</h3>
              <p>Implement solutions on the Azure platform</p>
              <div className="topics">
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Azure Virtual Machines and App Services</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Azure Active Directory</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Azure Storage and Cosmos DB</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Azure Networking services</div>
              </div>
            </div>
           
            <div className="curriculum-item">
              <h3><FontAwesomeIcon icon={faCode} className="me-2" /> Module 4: Infrastructure as Code</h3>
              <p>Automate cloud deployment and management</p>
              <div className="topics">
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Terraform for multi-cloud provisioning</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> AWS CloudFormation</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Azure Resource Manager</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Configuration management tools</div>
              </div>
            </div>
           
            <div className="curriculum-item">
              <h3><FontAwesomeIcon icon={faProjectDiagram} className="me-2" /> Module 5: Cloud Architecture & Security</h3>
              <p>Design secure, scalable cloud solutions</p>
              <div className="topics">
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> High availability and disaster recovery</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Microservices architecture</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Cloud security and compliance</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Cost optimization strategies</div>
              </div>
            </div>
          </section>
         
        </div>  
       
        <div className="course-sidebar">
          <div className="info-item">
            <div className="info-icon">
              <FontAwesomeIcon icon={faClock} />
            </div>
            <div className="info-content">
              <h4>Duration</h4>
              <p>14 Weeks (15 hrs/week)</p>
            </div>
          </div>
         
          <div className="info-item">
            <div className="info-icon">
              <FontAwesomeIcon icon={faCertificate} />
            </div>
            <div className="info-content">
              <h4>Level</h4>
              <p>Beginner to Advanced</p>
            </div>
          </div>
         
          <div className="info-item">
            <div className="info-icon">
              <FontAwesomeIcon icon={faLaptopCode} />
            </div>
            <div className="info-content">
              <h4>Hands-on Labs</h4>
              <p>50+ Practical Exercises</p>
            </div>
          </div>
         
          <div className="info-item">
            <div className="info-icon">
              <FontAwesomeIcon icon={faUsers} />
            </div>
            <div className="info-content">
              <h4>Prerequisites</h4>
              <p>Basic Networking, Linux Fundamentals</p>
            </div>
          </div>
         
          <div className="info-item">
            <div className="info-icon">
              <FontAwesomeIcon icon={faBriefcase} />
            </div>
            <div className="info-content">
              <h4>Certification Prep</h4>
              <p>AWS, Azure, GCP certification paths</p>
            </div>
          </div>
         
          <button className="btn btn-primary btn-lg px-4" onClick={openModal}>
                  Enroll Now
                </button>
        </div>
      </div>
    </div>
    {/* MODAL */}
      {showModal && (
        <div
          className="modal d-block fade show"
          style={{ background: 'rgba(0,0,0,0.5)' }}
          onClick={(e) => { if (e.target === e.currentTarget) closeModal(); }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content p-4 d-flex flex-column flex-md-row">
              <div className="w-100 w-md-50 mb-3 mb-md-0">
                <img
                  src="/img/enroll.jpg"
                  alt="Enrollment"
                  className="img-fluid h-100"
                  style={{ objectFit: 'cover', width: '100%' }}
                />
              </div>
              <div className="w-100 w-md-50 ps-md-4">
                <h6 className="text-primary">Course:</h6>
                <h4 className="fw-bold">Cloud Engineering</h4>
                <form onSubmit={handleSubmit} noValidate>
                  <input
                    className="form-control mb-3"
                    type="text"
                    name="fullName"
                    placeholder="Full Name"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    required
                  />
                  <input
                    className="form-control mb-3"
                    type="text"
                    name="mobileNumber"
                    placeholder="Mobile Number"
                    value={formData.mobileNumber}
                    onChange={handleInputChange}
                    required
                    maxLength={10}
                  />
                  <input
                    className="form-control mb-3"
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                  <div className="d-flex justify-content-end">
                    <button type="button" className="btn btn-outline-dark me-2" onClick={closeModal}>
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-primary">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
 
export default CloudEngineering;